(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elastica-konfigurator"] && !Shopify.designMode) return;
  try {
    
(function(){
function initializeKonfigurator(){
  var root = document.getElementById('elastica-konfigurator');
  if(!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  var compact = root.classList.contains("ekf--beratung");
  var liveData = JSON.parse(document.getElementById('ekf-product-data').textContent);
  var liveByHandle = {};
  liveData.forEach(function(p){ liveByHandle[p.handle] = p; });

  /* Statische Attribute (Härte / Position / Zielgruppe / Besonderheit) je Handle.
     Diese Werte bei neuen Produkten hier ergänzen. */
  /* Ja/Nein-Matrix 1:1 aus der Excel-Regeltabelle (Regelkonfigurator.xlsx) übernommen.
     forWhom: welche Zielgruppen dieses Produkt bedienen darf (erwachsen/kind/baby).
     match: Ja=true = Produkt passt zu dieser Quiz-Antwort. Bei neuen Produkten hier ergänzen. */
  var ATTRS = {
    "kaltschaummatratze-elastica-basic": { forWhom:["erwachsen","kind"], tag:"Einsteiger-Modell",
      match:{seite:false, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:true, fest:true, bis70:false, "71-90":true, "91-110":true, ueber110:false, natur:false, allergie:false, kuehlend:false, druckentlastung:false, atmung:false, premium:false, balance:true, komfortplus:false, premiumkomfort:false},
      highlights:["7-Zonen Kaltschaum","Einsteigerfreundlicher Preis","Für alle Schlafpositionen"] },
    "federkernmatratze-elastica-spring": { forWhom:["erwachsen","kind"], tag:"Federkern-Feel",
      match:{seite:false, ruecken:true, bauch:true, wechsel:true, weich:true, mittel:true, fest:false, bis70:true, "71-90":true, "91-110":true, ueber110:false, natur:false, allergie:false, kuehlend:true, druckentlastung:false, atmung:true, premium:false, balance:true, komfortplus:false, premiumkomfort:false},
      highlights:["7-Zonen Taschenfederkern","Gute Belüftung","Für Rücken- & Bauchschläfer"] },
    "kaltschaummatratze-elastica-star": { forWhom:["erwachsen","kind"], tag:"Für Kinder",
      match:{seite:false, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:true, fest:true, bis70:false, "71-90":true, "91-110":true, ueber110:false, natur:false, allergie:true, kuehlend:false, druckentlastung:true, atmung:false, premium:false, balance:true, komfortplus:false, premiumkomfort:false},
      highlights:["Speziell für Kinderschlaf","Ergonomische Unterstützung","Ab 6 Jahren"] },
    "kaltschaummatratze-elastica-sky": { forWhom:["erwachsen","kind"], tag:"Allrounder",
      match:{seite:true, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:true, fest:true, bis70:false, "71-90":true, "91-110":true, ueber110:true, natur:false, allergie:true, kuehlend:false, druckentlastung:false, atmung:false, premium:false, balance:false, komfortplus:true, premiumkomfort:false},
      highlights:["7-Zonen Kaltschaum","Passt zu jeder Schlafposition","Gutes Preis-Leistungs-Verhältnis"] },
    "federkernmatratze-elastica-flow": { forWhom:["erwachsen","kind"], tag:"Premium-Federkern",
      match:{seite:true, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:true, fest:true, bis70:true, "71-90":true, "91-110":true, ueber110:false, natur:false, allergie:false, kuehlend:true, druckentlastung:false, atmung:true, premium:false, balance:false, komfortplus:true, premiumkomfort:false},
      highlights:["7-Zonen Taschenfederkern","Hohe Punktelastizität","Für Rücken- & Bauchschläfer"] },
    "elastica-viscogel-mittelfest": { forWhom:["erwachsen","kind"], tag:"Kühlend",
      match:{seite:true, ruecken:false, bauch:false, wechsel:true, weich:true, mittel:true, fest:false, bis70:true, "71-90":true, "91-110":false, ueber110:false, natur:false, allergie:false, kuehlend:true, druckentlastung:true, atmung:true, premium:false, balance:false, komfortplus:true, premiumkomfort:false},
      highlights:["Gelschaum-Topper kühlt","Ideal für Seitenschläfer","Mittelfest H2"] },
    "elastica-viscogel-fest": { forWhom:["erwachsen","kind"], tag:"Kühlend",
      match:{seite:true, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:false, fest:true, bis70:false, "71-90":false, "91-110":true, ueber110:true, natur:false, allergie:true, kuehlend:true, druckentlastung:true, atmung:true, premium:false, balance:false, komfortplus:true, premiumkomfort:false},
      highlights:["Gelschaum-Topper kühlt","Feste Stützkraft H3","Ideal für Rücken- & Bauchschläfer"] },
    "kaltschaummatratze-elastica-cube": { forWhom:["erwachsen"], tag:"Wendematratze",
      match:{seite:true, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:true, fest:true, bis70:false, "71-90":true, "91-110":true, ueber110:false, natur:false, allergie:true, kuehlend:false, druckentlastung:true, atmung:true, premium:false, balance:false, komfortplus:true, premiumkomfort:false},
      highlights:["Beidseitig nutzbar (H2 + H3)","Perfekt bei wechselnder Position","3D-Wendefunktion"] },
    "federkernmatratze-elastica-luxury": { forWhom:["erwachsen"], tag:"Premium-Federkern",
      match:{seite:true, ruecken:true, bauch:true, wechsel:true, weich:true, mittel:true, fest:true, bis70:true, "71-90":true, "91-110":true, ueber110:true, natur:false, allergie:true, kuehlend:true, druckentlastung:true, atmung:true, premium:true, balance:false, komfortplus:true, premiumkomfort:false},
      highlights:["7-Zonen Taschenfederkern Premium","Hoher Liegekomfort","Für höchste Ansprüche"] },
    "kaltschaummatratze-elastica-pearl": { forWhom:["erwachsen"], tag:"Premium-Allrounder",
      match:{seite:true, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:true, fest:true, bis70:false, "71-90":true, "91-110":true, ueber110:true, natur:false, allergie:true, kuehlend:false, druckentlastung:true, atmung:true, premium:true, balance:false, komfortplus:false, premiumkomfort:true},
      highlights:["Höchster Schlafkomfort","Perfekte Unterstützung","Premium-Verarbeitung"] },
    "kaltschaummatratze-elastogen-air": { forWhom:["erwachsen"], tag:"Allergiker",
      match:{seite:false, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:true, fest:true, bis70:false, "71-90":true, "91-110":true, ueber110:true, natur:false, allergie:true, kuehlend:true, druckentlastung:false, atmung:true, premium:true, balance:false, komfortplus:false, premiumkomfort:true},
      highlights:["Speziell für Allergiker","Reduziert Allergene","Atmungsaktiv"] },
    "kaltschaummatratze-elastica-hre": { forWhom:["erwachsen"], tag:"Naturmaterialien",
      match:{seite:true, ruecken:true, bauch:true, wechsel:true, weich:false, mittel:true, fest:true, bis70:false, "71-90":true, "91-110":true, ueber110:true, natur:true, allergie:true, kuehlend:true, druckentlastung:false, atmung:true, premium:true, balance:false, komfortplus:false, premiumkomfort:true},
      highlights:["Nachhaltige Naturmaterialien","Ökologisch produziert","Hoher Liegekomfort"] },
    "latexmatratze-elastica-pure": { forWhom:["erwachsen"], tag:"100% Naturlatex",
      match:{seite:true, ruecken:false, bauch:false, wechsel:false, weich:true, mittel:true, fest:false, bis70:true, "71-90":true, "91-110":false, ueber110:false, natur:true, allergie:true, kuehlend:false, druckentlastung:true, atmung:false, premium:true, balance:false, komfortplus:false, premiumkomfort:true},
      highlights:["100% Naturlatex","Ideal für Seitenschläfer","Mittelfest H2"] },
    "elastica-pure-fest": { forWhom:["erwachsen"], tag:"100% Naturlatex",
      match:{seite:true, ruecken:true, bauch:true, wechsel:false, weich:false, mittel:false, fest:true, bis70:false, "71-90":false, "91-110":true, ueber110:true, natur:true, allergie:true, kuehlend:false, druckentlastung:true, atmung:false, premium:true, balance:false, komfortplus:false, premiumkomfort:true},
      highlights:["100% Naturlatex","Feste Stützkraft H3","Für Rücken- & Bauchschläfer"] },
    "kaltschaummatratze-kuschelnest": { forWhom:["baby"], tag:"Baby & Kleinkind", match:{},
      highlights:["Wendbar: Baby-Seite & Kleinkind-Seite in einer Matratze","Stabile Randzonenverstärkung","Smartcel Sensitive Bezug – schützt empfindliche Babyhaut und wirkt antibakteriell","Hygienisch bei 60°C waschbar – abnehmbarer Bezug für ein frisches Schlafgefühl","In 60x120 & 70x140 cm erhältlich"] }
  };

  var PRODUCTS = liveData
    .filter(function(p){ return ATTRS[p.handle]; })
    .map(function(p){
      var a = ATTRS[p.handle];
      return {
        title: p.title, handle: p.handle, type: p.type, price: p.price, image: p.image, url: p.url,
        available: p.available,
        reviewRating: p.reviewRating, reviewCount: p.reviewCount,
        forWhom: a.forWhom, match: a.match,
        tag: a.tag, highlights: a.highlights
      };
    });

  /* Fragen 1:1 aus dem bestehenden Perfect-Product-Finder/Lantern-Quiz von Elastica übernommen */
  var STEPS = ["name","forWhom","position","firmness","weight","wishes","budget","loading","result"];
  if(compact) STEPS = STEPS.filter(function(step){ return step !== "name"; });
  var answers = { name:"", forWhom:null, position:null, firmness:null, weight:null, wishes:[], budget:null };
  var stepIndex = 0;

  function escapeHtml(value){
    return String(value || '').replace(/[&<>"']/g, function(char){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char];
    });
  }
  function displayName(){ return escapeHtml(answers.name && answers.name.trim() ? answers.name.trim() : "Gast"); }

  function greeting(text, separator){
    if(compact) return text.charAt(0).toUpperCase() + text.slice(1);
    return displayName() + separator + text;
  }

  function visibleSteps(){
    // Für Babys gibt es nur ein Produkt (Kuschelnest) — Fragen zu Liegegefühl,
    // Gewicht, Wünschen und Budget wären hier sinnlos, da sie das Ergebnis nicht ändern.
    if(answers.forWhom === "baby") return compact ? ["forWhom","loading","result"] : ["name","forWhom","loading","result"];
    return STEPS;
  }
  function renderProgress(){
    var steps = visibleSteps().filter(function(s){return s!=="result" && s!=="loading";});
    var total = steps.length;
    var isResult = visibleSteps()[stepIndex] === "result";
    var doneCount = isResult ? total : stepIndex;
    var el = document.getElementById("ekfProgress");
    el.innerHTML = "";
    for(var i=0;i<total;i++){
      var seg = document.createElement("div");
      seg.className = "seg" + (i < doneCount || isResult ? " done":"");
      el.appendChild(seg);
    }
  }
  function next(){ var steps = visibleSteps(); stepIndex = Math.min(stepIndex+1, steps.length-1); render(); }
  function back(){ var steps = visibleSteps(); stepIndex = Math.max(stepIndex-1, 0); render(); }
  function restart(){ answers = { name:"", forWhom:null, position:null, firmness:null, weight:null, wishes:[], budget:null }; stepIndex = 0; render(); }

  function optionButton(value, current, label, sub, icon, multi){
    var selected = multi ? current.indexOf(value) > -1 : current===value;
    return '<button type="button" class="ekf-opt'+(selected?' selected':'')+'" data-value="'+value+'">'+
      '<span class="ekf-icon">'+(icon||"")+'</span>'+
      '<span class="ekf-label">'+label+'</span>'+
      (sub?'<span class="ekf-sub">'+sub+'</span>':'')+
      '</button>';
  }

  function photoOption(value, current, label, sub, imgUrl, multi, shape){
    var selected = multi ? current.indexOf(value) > -1 : current===value;
    var shapeClass = shape==='tall' ? ' ekf-opt-photo-tall' : shape==='square' ? ' ekf-opt-photo-square' : '';
    return '<button type="button" class="ekf-opt ekf-opt-photo'+shapeClass+(selected?' selected':'')+'" data-value="'+value+'">'+
      '<img src="'+imgUrl+'" alt="" loading="lazy">'+
      (selected?'<span class="ekf-opt-check">✓</span>':'')+
      '<span class="ekf-opt-photo-text">'+
        '<span class="ekf-label">'+label+'</span>'+
        (sub?'<span class="ekf-sub">'+sub+'</span>':'')+
      '</span>'+
      '</button>';
  }

  /* Fotos: Schlafpositionen = Original-Kartenmotive aus der Elastica-Mediathek (Shopify Files).
     Für-wen-Fotos = lizenzfreie Unsplash-Fotos (Unsplash-Lizenz, kommerziell nutzbar). */
  var PHOTOS = {
    erwachsen: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-fuerwen-erwachsene.png",
    kind: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-fuerwen-kind.png",
    baby: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-fuerwen-baby.png",
    seite: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-position-seite.png",
    ruecken: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-position-ruecken.png",
    bauch: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-position-bauch.png",
    wechsel: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-position-gemischt.png",
    weich: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-firmness-weich.png",
    mittel: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-firmness-mittelfest.png",
    fest: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-firmness-fest.png",
    gewichtBis70: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-gewicht-sil2-bis70.png",
    gewicht7190: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-gewicht-sil2-71-90.png",
    gewicht91110: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-gewicht-sil2-91-110.png",
    gewichtUeber110: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-gewicht-sil2-ueber110.png"
  };
  var WAAGE_FOTO = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-waage.png";
  var WISH_PHOTOS = {
    natur: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-wunsch-natur.png",
    allergie: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-wunsch-allergie.png",
    atmung: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-wunsch-atmung.png",
    druckentlastung: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-wunsch-druckentlastung.png",
    keine: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-wunsch-keine.png",
    kuehlend: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-wunsch-kuehlend.png",
    premium: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-wunsch-premium.png"
  };
  var BUDGET_PHOTOS = {
    balance: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-budget-balance.png",
    komfortplus: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-budget-komfortplus.png",
    premiumkomfort: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-budget-premium.png",
    beratung: "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-budget-beratung.png"
  };


  /* Optimized consultation illustrations; other page instances keep their existing assets. */
  if(compact){
    PHOTOS.erwachsen = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-erwachsene.webp?v=1791886886";
    PHOTOS.kind = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-kinder-jugendliche.webp?v=1791886886";
    PHOTOS.baby = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-baby.webp?v=1791886885";
    PHOTOS.seite = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-seitenschlaefer.webp?v=1791886885";
    PHOTOS.ruecken = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-rueckenschlaefer.webp?v=1791886886";
    PHOTOS.bauch = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-bauchschlaefer.webp?v=1791886886";
    PHOTOS.wechsel = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-mischschlaefer.webp?v=1791886886";
    PHOTOS.weich = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-liegegefuehl-weich.webp?v=1791886886";
    PHOTOS.mittel = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-liegegefuehl-mittelfest.webp?v=1791886886";
    PHOTOS.fest = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-liegegefuehl-fest.webp?v=1791886886";
    PHOTOS.gewichtBis70 = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-koerpergewicht-bis-70-kg.webp?v=1791886885";
    PHOTOS.gewicht7190 = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-koerpergewicht-71-90-kg.webp?v=1791886885";
    PHOTOS.gewicht91110 = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-koerpergewicht-91-110-kg.webp?v=1791886885";
    PHOTOS.gewichtUeber110 = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-koerpergewicht-ueber-110-kg.webp?v=1791886885";
    WISH_PHOTOS.natur = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-naturmaterialien.webp?v=1791886886";
    WISH_PHOTOS.allergie = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-allergikerfreundlich.webp?v=1791886885";
    WISH_PHOTOS.kuehlend = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-kuehlende-wirkung.webp?v=1791886886";
    WISH_PHOTOS.druckentlastung = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-druckentlastung.webp?v=1791886885";
    WISH_PHOTOS.atmung = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-atmungsaktivitaet.webp?v=1791886886";
    WISH_PHOTOS.premium = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-premiumkomfort.webp?v=1791886886";
    WISH_PHOTOS.keine = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-keine-besonderen-wuensche.webp?v=1791886885";
    BUDGET_PHOTOS.balance = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-balance.webp?v=1791886886";
    BUDGET_PHOTOS.komfortplus = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-komfort-plus.webp?v=1791886886";
    BUDGET_PHOTOS.premiumkomfort = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-premium-komfort.webp?v=1791886886";
    BUDGET_PHOTOS.beratung = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-persoenliche-beratung.webp?v=1791886886";
    WAAGE_FOTO = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-matratzenberatung-waage.webp?v=1791886886";
  }

  function wishOption(value, current, label, imgUrl, multi, wide){
    var selected = multi ? current.indexOf(value) > -1 : current===value;
    return '<button type="button" class="ekf-opt ekf-opt-wish'+(wide?' ekf-opt-wish-wide':'')+(selected?' selected':'')+'" data-value="'+value+'">'+
      '<img src="'+imgUrl+'" alt="" loading="lazy">'+
      (selected?'<span class="ekf-opt-check">✓</span>':'')+
      '<span class="ekf-opt-wish-label">'+label+'</span>'+
      '</button>';
  }
  var MAX_HALLO = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-max-hallo.png";
  var MAX_SCHAFE = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-max-schafe.png";
  var BERATUNG_FOTO = "https://cdn.shopify.com/s/files/1/0977/8062/9768/files/elastica-beratung.png";

  function wireSingle(field){
    var opts = document.querySelectorAll("#ekfApp .ekf-opt");
    for(var i=0;i<opts.length;i++){
      opts[i].addEventListener("click", (function(btn){ return function(){ answers[field] = btn.getAttribute("data-value"); render(); }; })(opts[i]));
    }
    var backBtn = document.getElementById("ekfBack");
    if(backBtn) backBtn.addEventListener("click", back);
    var nextBtn = document.getElementById("ekfNext");
    if(nextBtn) nextBtn.addEventListener("click", function(){ if(!nextBtn.disabled) next(); });
  }

  function wireMulti(field){
    var opts = document.querySelectorAll("#ekfApp .ekf-opt");
    for(var i=0;i<opts.length;i++){
      opts[i].addEventListener("click", (function(btn){ return function(){
        var val = btn.getAttribute("data-value");
        if(val === "keine"){ answers[field] = ["keine"]; }
        else {
          var idx = answers[field].indexOf(val);
          if(idx > -1){ answers[field].splice(idx,1); }
          else { answers[field] = answers[field].filter(function(v){return v!=="keine";}).concat([val]); }
        }
        render();
      }; })(opts[i]));
    }
    document.getElementById("ekfBack").addEventListener("click", back);
    document.getElementById("ekfNext").addEventListener("click", next);
  }

  function render(){
    renderProgress();
    var steps = visibleSteps();
    var step = steps[stepIndex];
    root.dataset.step = step;
    var app = document.getElementById("ekfApp");
    var contactTemplate = document.getElementById("ekfBeratungTemplate");
    if(contactTemplate && app.contains(contactTemplate)){
      root.querySelector('.ekf-wrap').appendChild(contactTemplate);
      contactTemplate.style.display = 'none';
    }
    var questionCount = steps.filter(function(s){return s!=="result" && s!=="loading";}).length;
    var stepLabel = "Schritt "+(stepIndex+1)+" von "+questionCount;

    if(step === "name"){
      app.innerHTML =
        '<div class="ekf-card">'+
          '<img class="ekf-mascot" src="'+MAX_HALLO+'" alt="Max von Elastica">'+
          '<div class="ekf-step-label">'+stepLabel+'</div>'+
          '<div class="ekf-step-title">Bevor wir starten: Wie darf ich dich ansprechen?</div>'+
          '<div class="ekf-step-sub">Optional — für eine persönlichere Empfehlung.</div>'+
          '<input type="text" id="ekfNameInput" class="ekf-text-input" placeholder="Dein Vorname" value="'+escapeHtml(answers.name)+'">'+
          '<div class="ekf-nav-row"><span></span><button class="ekf-btn primary" id="ekfNext">Weiter</button></div>'+
        '</div>';
      document.getElementById("ekfNext").addEventListener("click", function(){
        answers.name = document.getElementById("ekfNameInput").value;
        next();
      });
    }

    if(step === "forWhom"){
      app.innerHTML =
        '<div class="ekf-card">'+
          '<div class="ekf-step-label">'+stepLabel+'</div>'+
          '<div class="ekf-step-title">'+greeting("für wen suchst du eine Schlaflösung?",", ")+'</div>'+
          '<div class="ekf-step-sub">So kann ich die Empfehlung optimal auf die Bedürfnisse abstimmen.</div>'+
          '<div class="ekf-options">'+
            photoOption("erwachsen",answers.forWhom,"Erwachsene","",PHOTOS.erwachsen)+
            photoOption("kind",answers.forWhom,"Kinder / Jugendliche","",PHOTOS.kind)+
            photoOption("baby",answers.forWhom,"Baby","",PHOTOS.baby)+
          '</div>'+
          '<div class="ekf-nav-row"><button class="ekf-btn ghost" id="ekfBack">Zurück</button><button class="ekf-btn primary" id="ekfNext" '+(answers.forWhom?'':'disabled')+'>Weiter</button></div>'+
        '</div>';
      wireSingle("forWhom");
    }

    if(step === "position"){
      app.innerHTML =
        '<div class="ekf-card">'+
          '<div class="ekf-step-label">'+stepLabel+'</div>'+
          '<div class="ekf-step-title">'+greeting("welche Schlafposition trifft am ehesten auf dich zu?",", ")+'</div>'+
          '<div class="ekf-step-sub">Damit ich die passende Schlaflösung empfehlen kann, möchte ich wissen, wie du hauptsächlich schläfst.</div>'+
          '<div class="ekf-options">'+
            photoOption("seite",answers.position,"Seitenschläfer","",PHOTOS.seite,false,'tall')+
            photoOption("ruecken",answers.position,"Rückenschläfer","",PHOTOS.ruecken,false,'tall')+
            photoOption("bauch",answers.position,"Bauchschläfer","",PHOTOS.bauch,false,'tall')+
            photoOption("wechsel",answers.position,"Mischschläfer","",PHOTOS.wechsel,false,'tall')+
          '</div>'+
          '<div class="ekf-nav-row"><button class="ekf-btn ghost" id="ekfBack">Zurück</button><button class="ekf-btn primary" id="ekfNext" '+(answers.position?'':'disabled')+'>Weiter</button></div>'+
        '</div>';
      wireSingle("position");
    }

    if(step === "firmness"){
      app.innerHTML =
        '<div class="ekf-card">'+
          '<div class="ekf-step-label">'+stepLabel+'</div>'+
          '<div class="ekf-step-title">'+greeting("wie möchtest du liegen?",", ")+'</div>'+
          '<div class="ekf-step-sub">Jeder Mensch empfindet Liegekomfort anders. Wähle die Variante, die deinem persönlichen Gefühl am nächsten kommt.</div>'+
          '<div class="ekf-options">'+
            photoOption("weich",answers.firmness,"Sanft / Weich","",PHOTOS.weich,false,'square')+
            photoOption("mittel",answers.firmness,"Mittelfest","",PHOTOS.mittel,false,'square')+
            photoOption("fest",answers.firmness,"Fest","",PHOTOS.fest,false,'square')+
          '</div>'+
          '<div class="ekf-nav-row"><button class="ekf-btn ghost" id="ekfBack">Zurück</button><button class="ekf-btn primary" id="ekfNext" '+(answers.firmness?'':'disabled')+'>Weiter</button></div>'+
        '</div>';
      wireSingle("firmness");
    }

    if(step === "weight"){
      app.innerHTML =
        '<div class="ekf-card">'+
          '<img class="ekf-card-corner-icon" src="'+WAAGE_FOTO+'" alt="">'+
          '<div class="ekf-step-label">'+stepLabel+'</div>'+
          '<div class="ekf-step-title">Welcher Gewichtsbereich trifft auf dich zu?</div>'+
          '<div class="ekf-step-sub">'+greeting("mit dieser Angabe kann ich die optimale Schlaflösung noch genauer auf dich abstimmen."," — ")+'</div>'+
          '<div class="ekf-options">'+
            optionButton("bis70",answers.weight,"Bis 70 kg","Leichter Körperbau. Komfort steht im Vordergrund.",'<img src="'+PHOTOS.gewichtBis70+'" alt="" style="width:64px;height:64px;object-fit:contain;">')+
            optionButton("71-90",answers.weight,"71 – 90 kg","Komfort und Stabilität in guter Balance.",'<img src="'+PHOTOS.gewicht7190+'" alt="" style="width:64px;height:64px;object-fit:contain;">')+
            optionButton("91-110",answers.weight,"91 – 110 kg","Höherer Unterstützungsbedarf für Wirbelsäule und Gelenke.",'<img src="'+PHOTOS.gewicht91110+'" alt="" style="width:64px;height:64px;object-fit:contain;">')+
            optionButton("ueber110",answers.weight,"Über 110 kg","Maximale Unterstützung, hohe Formstabilität und Langlebigkeit.",'<img src="'+PHOTOS.gewichtUeber110+'" alt="" style="width:64px;height:64px;object-fit:contain;">')+
          '</div>'+
          '<div class="ekf-nav-row"><button class="ekf-btn ghost" id="ekfBack">Zurück</button><button class="ekf-btn primary" id="ekfNext" '+(answers.weight?'':'disabled')+'>Weiter</button></div>'+
        '</div>';
      wireSingle("weight");
    }

    if(step === "wishes"){
      app.innerHTML =
        '<div class="ekf-card">'+
          '<div class="ekf-step-label">'+stepLabel+'</div>'+
          '<div class="ekf-step-title">'+greeting("wähle die Eigenschaften aus, die dir besonders wichtig sind.",", ")+'</div>'+
          '<div class="ekf-step-sub">Je besser ich deine Wünsche kenne, desto genauer kann ich die passende Empfehlung für dich finden.</div>'+
          '<div class="ekf-multi-hint">Mehrfachauswahl möglich</div>'+
          '<div class="ekf-options ekf-options-center">'+
            wishOption("natur",answers.wishes,"Naturmaterialien",WISH_PHOTOS.natur,true)+
            wishOption("allergie",answers.wishes,"Allergikerfreundlich",WISH_PHOTOS.allergie,true)+
            wishOption("kuehlend",answers.wishes,"Kühlende Wirkung",WISH_PHOTOS.kuehlend,true)+
            wishOption("druckentlastung",answers.wishes,"Hohe Druckentlastung",WISH_PHOTOS.druckentlastung,true)+
            wishOption("atmung",answers.wishes,"Hohe Atmungsaktivität",WISH_PHOTOS.atmung,true)+
            wishOption("premium",answers.wishes,"Premiumkomfort",WISH_PHOTOS.premium,true)+
            wishOption("keine",answers.wishes,"Keine besonderen Wünsche",WISH_PHOTOS.keine,true)+
          '</div>'+
          '<div class="ekf-nav-row"><button class="ekf-btn ghost" id="ekfBack">Zurück</button><button class="ekf-btn primary" id="ekfNext">Weiter</button></div>'+
        '</div>';
      wireMulti("wishes");
    }

    if(step === "budget"){
      app.innerHTML =
        '<div class="ekf-card">'+
          '<div class="ekf-step-label">'+stepLabel+'</div>'+
          '<div class="ekf-step-title">'+greeting("welche Investition in deinen Schlaf fühlt sich für dich richtig an?",", ")+'</div>'+
          '<div class="ekf-options ekf-options-center">'+
            wishOption("balance",answers.budget,"Balance",BUDGET_PHOTOS.balance,false,true)+
            wishOption("komfortplus",answers.budget,"Komfort Plus",BUDGET_PHOTOS.komfortplus,false,true)+
            wishOption("premiumkomfort",answers.budget,"Premium Komfort",BUDGET_PHOTOS.premiumkomfort,false,true)+
            wishOption("beratung",answers.budget,"Persönliche Beratung",BUDGET_PHOTOS.beratung,false,true)+
          '</div>'+
          '<div class="ekf-nav-row"><button class="ekf-btn ghost" id="ekfBack">Zurück</button><button class="ekf-btn primary" id="ekfNext" '+(answers.budget?'':'disabled')+'>Ergebnis anzeigen</button></div>'+
        '</div>';
      wireSingle("budget");
    }

    if(step === "loading"){
      app.innerHTML =
        '<div class="ekf-card ekf-loading-card">'+
          (compact ? '<span class="ekf-loading-indicator" role="status" aria-label="Deine Empfehlung wird ermittelt"></span>' : '<img class="ekf-mascot" src="'+MAX_SCHAFE+'" alt="Max ermittelt deine Schlaflösung">')+
          '<p style="color:var(--ekf-text-muted);">Jeder Mensch schläft anders. Deshalb erhältst du gleich eine Empfehlung, die auf deine Bedürfnisse abgestimmt ist.</p>'+
        '</div>';
      setTimeout(next, 1600);
    }

    if(step === "result"){
      if(answers.forWhom === "baby"){
        var babyP = null;
        PRODUCTS.forEach(function(pr){ if(pr.forWhom.indexOf("baby")>-1) babyP = pr; });
        if(babyP){
          app.innerHTML =
            '<div class="ekf-card">'+
              '<div class="ekf-results-head"><h2>Deine Empfehlung</h2><p>'+greeting("für Babys & Kleinkinder empfehlen wir ausschließlich unser Kuschelnest.",", ")+'</p></div>'+
              '<div style="max-width:340px;margin:28px auto 0;">'+
                '<div class="ekf-pcard">'+
                  '<img src="'+babyP.image+'" alt="'+babyP.title+'" loading="lazy">'+
                  '<div class="ekf-pcard-body">'+
                    '<span class="ekf-pcard-type">'+babyP.tag+'</span>'+
                    '<span class="ekf-pcard-title">'+babyP.title+'</span>'+
                    '<span class="ekf-pcard-price">ab '+babyP.price+' €</span>'+
                    '<div class="ekf-why-box">'+
                      '<span class="ekf-why-label">Darum ist das Kuschelnest ideal</span>'+
                      '<ul>'+babyP.highlights.map(function(h){return '<li>'+h+'</li>';}).join('')+'</ul>'+
                    '</div>'+
                    '<a class="ekf-pcard-cta" href="'+babyP.url+'">Jetzt ansehen</a>'+
                  '</div>'+
                '</div>'+
              '</div>'+
              '<button class="ekf-restart" id="ekfRestart">Konfiguration neu starten</button>'+
            '</div>';
          document.getElementById("ekfRestart").addEventListener("click", restart);
          return;
        }
      }
      if(answers.budget === "beratung"){
        app.innerHTML =
          '<div class="ekf-card" style="text-align:center;">'+
            '<img class="ekf-beratung-photo" src="'+BERATUNG_FOTO+'" alt="Persönliche Beratung bei Elastica">'+
            '<div class="ekf-results-head"><h2>Persönliche Beratung gewünscht</h2><p>'+greeting("gerne beraten wir dich individuell zu deiner optimalen Schlaflösung.",", ")+'</p></div>'+
            '<div id="ekfBeratungSlot"></div>'+
            '<button class="ekf-restart" id="ekfRestart">Konfiguration neu starten</button>'+
          '</div>';
        var slot = document.getElementById("ekfBeratungSlot");
        var tpl = document.getElementById("ekfBeratungTemplate");
        if(slot && tpl){
          slot.appendChild(tpl);
          tpl.style.display = "";
          var nameEl = document.getElementById("ekfCfName");
          var msgEl = document.getElementById("ekfCfMsg");
          if(nameEl && !nameEl.value && answers.name) nameEl.value = answers.name;
          if(msgEl && !msgEl.value) msgEl.value = "Ich interessiere mich für eine persönliche Beratung zu meiner Schlaflösung (via Matratzenkonfigurator).";
        }
        document.getElementById("ekfRestart").addEventListener("click", restart);
        return;
      }
      var results = getRecommendations();
      var reasonCounts = [5,4,3];
      var rankBadges = ["Beste Wahl","Gute Alternative","Ebenfalls empfehlenswert"];
      app.innerHTML =
        '<div class="ekf-card">'+
          '<div class="ekf-results-head"><h2>Deine Top-Empfehlungen</h2><p>'+greeting("basierend auf deinen Angaben — die 3 besten Treffer aus unserem Sortiment.",", ")+'</p></div>'+
          '<div class="ekf-results-grid">'+
            results.map(function(p,i){
              var reasons = reasonsFor(p).slice(0, reasonCounts[i]);
              return '<div class="ekf-pcard '+(i===0?'best':'')+'">'+
                '<span class="'+(i===0?'ekf-best-badge':'ekf-alt-badge')+'">'+rankBadges[i]+'</span>'+
                '<img src="'+p.image+'" alt="'+p.title+'" loading="lazy">'+
                '<div class="ekf-pcard-body">'+
                  '<span class="ekf-pcard-type">'+p.tag+'</span>'+
                  '<span class="ekf-pcard-title">'+p.title+'</span>'+
                  '<span class="ekf-pcard-price">ab '+p.price+' € <span>/ ab Größe 90×190 cm</span></span>'+
                  (p.reviewCount > 0 ? '<a class="ekf-review-badge" href="'+p.url+'#judgeme_product_reviews" target="_blank" rel="noopener">★ '+parseFloat(p.reviewRating).toFixed(1)+' <span>('+p.reviewCount+' Bewertungen)</span></a>' : '')+
                  '<div class="ekf-why-box">'+
                    '<span class="ekf-why-label">Warum das zu dir passt</span>'+
                    '<ul>'+reasons.map(function(r){return '<li>'+r+'</li>';}).join('')+'</ul>'+
                  '</div>'+
                  '<a class="ekf-pcard-cta" href="'+p.url+'">Jetzt ansehen</a>'+
                '</div>'+
              '</div>';
            }).join('')+
          '</div>'+

          '<div class="ekf-trust-bar">'+
            '<span class="ekf-trust-item"><svg class="ekf-trust-flag" viewBox="0 0 3 2"><rect width="3" height="2" fill="#ED2939"/><rect y="0.6667" width="3" height="0.6667" fill="#fff"/></svg>100% Made in Austria</span>'+
            '<span class="ekf-trust-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h12l4 6-10 12L2 9Z"/><path d="M11 3 8 9l4 12 4-12-3-6"/><path d="M2 9h20"/></svg>Schlafqualität seit 1976</span>'+
          '</div>'+

          '<div class="ekf-unsure-box">'+
            '<p class="ekf-unsure-text">Unsicher bei der Wahl? Wir beraten dich gerne persönlich.</p>'+
            '<div class="ekf-unsure-actions">'+
              '<a class="ekf-unsure-btn ekf-whatsapp-btn" href="https://wa.me/436601486595?text=Hallo%2C%20ich%20h%C3%A4tte%20gerne%20eine%20pers%C3%B6nliche%20Beratung%20zu%20meiner%20Matratze." target="_blank" rel="noopener">WhatsApp-Chat starten</a>'+
              '<button class="ekf-unsure-btn ghost" id="ekfUnsureBeratungBtn">Jetzt beraten lassen</button>'+
            '</div>'+
          '</div>'+

          '<button class="ekf-restart" id="ekfRestart">Konfiguration neu starten</button>'+
        '</div>';
      document.getElementById("ekfRestart").addEventListener("click", restart);
      document.getElementById("ekfUnsureBeratungBtn").addEventListener("click", function(){
        answers.budget = "beratung";
        render();
      });
    }
  }

  /* Basiert 1:1 auf der Ja/Nein-Matrix aus der Excel-Regeltabelle (Regelkonfigurator.xlsx). */
  var WISH_POINTS = { natur:6, allergie:8, kuehlend:6, druckentlastung:5, atmung:5, premium:5 };
  // 100% Naturlatex ist unser Naturmaterialien-Spezialist: bei diesem Wunsch soll die passende
  // Pure-Variante (H2 oder H3, je nach Liegegefühl) immer vor anderen "natur"-Produkten wie der HRE liegen.
  var NATUR_SPECIALIST_BONUS = 12;

  function reasonsFor(p){
    var r = [];
    var m = p.match;

    if(answers.firmness && m[answers.firmness]){
      var fLabel = { weich:"Weich", mittel:"Mittelfest", fest:"Fest" }[answers.firmness];
      r.push(fLabel + " – genau dein Liegegefühl");
    }

    if(answers.position && m[answers.position]){
      var pLabel = { seite:"Seitenschläfer", ruecken:"Rückenschläfer", bauch:"Bauchschläfer", wechsel:"wechselnde Schlafpositionen" }[answers.position];
      r.push(answers.position === "wechsel" ? "Perfekt für " + pLabel : "Ideal für " + pLabel);
    }

    if(answers.weight && m[answers.weight]) r.push("Auf dein Körpergewicht abgestimmt");

    var WISH_LABELS = {
      natur:"Nachhaltige Naturmaterialien", allergie:"Allergikerfreundlich", kuehlend:"Kühlende Wirkung bei Hitze",
      druckentlastung:"Hohe Druckentlastung", atmung:"Hohe Atmungsaktivität", premium:"Premium-Komfort"
    };
    answers.wishes.forEach(function(w){ if(w !== "keine" && m[w] && WISH_LABELS[w]) r.push(WISH_LABELS[w]); });

    if(answers.budget && m[answers.budget]) r.push("Im Rahmen deines Budgets");

    p.highlights.forEach(function(h){ if(r.indexOf(h) === -1 && r.length < 5) r.push(h); });

    return r;
  }

  function scoreProduct(p){
    if(answers.forWhom === "baby") return p.forWhom.indexOf("baby")>-1 ? 1000 : -1000;
    if(p.forWhom.indexOf(answers.forWhom) === -1) return -1000;

    var score = 0;
    var m = p.match;

    if(answers.firmness && m[answers.firmness]) score += 6;

    if(answers.position && m[answers.position]) score += (answers.position === "wechsel" ? 4 : 2);

    if(answers.weight && m[answers.weight]) score += (answers.weight === "ueber110" ? 3 : 2);

    answers.wishes.forEach(function(w){
      if(w !== "keine" && m[w]){
        score += WISH_POINTS[w];
        if(w === "natur" && p.type === "Latexmatratze") score += NATUR_SPECIALIST_BONUS;
      }
    });

    if(answers.budget === "balance") score += m.balance ? 5 : -8;
    if(answers.budget === "komfortplus") score += m.komfortplus ? 5 : 0;
    if(answers.budget === "premiumkomfort") score += m.premiumkomfort ? 5 : -3;

    if(!p.available) score -= 50;
    return score;
  }

  function getRecommendations(){
    return PRODUCTS.filter(function(p){ return p.forWhom.indexOf(answers.forWhom) > -1; }).map(function(p){ p._score = scoreProduct(p); return p; })
      .sort(function(a,b){ return b._score - a._score; })
      .slice(0,3);
  }

  if(root.querySelector('.ekf-form-success, .ekf-form-error')){
    answers.budget = 'beratung';
    stepIndex = STEPS.indexOf('result');
  }
  render();
}
initializeKonfigurator();
document.addEventListener('shopify:section:load', initializeKonfigurator);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const mobileVideoPreviewQuery = window.matchMedia('(max-width: 767px)');

    const patchMediaGalleryAutoplay = () => {
      const MediaGalleryElement = customElements.get('media-gallery');

      if (!MediaGalleryElement) {
        customElements.whenDefined('media-gallery').then(patchMediaGalleryAutoplay);
        return;
      }

      const mediaGalleryPrototype = MediaGalleryElement.prototype;
      if (mediaGalleryPrototype.elasticaRespectsAutoplaySetting) return;

      mediaGalleryPrototype.playActiveMedia = function(activeMedia) {
        if (typeof activeMedia === 'undefined') return;

        const activeDeferredMedia = activeMedia.querySelector('.deferred-media');

        this.sliderGallery.querySelectorAll('.deferred-media').forEach((media) => {
          if (media === activeDeferredMedia && media.hasAttribute('autoplay')) {
            media.play();
          } else {
            media.pause();
          }
        });
      };

      Object.defineProperty(mediaGalleryPrototype, 'elasticaRespectsAutoplaySetting', {
        value: true,
        configurable: true
      });
    };

    const initializePurchasePanels = (scope) => {
      scope.querySelectorAll('product-info.product__info').forEach((productInfo) => {
        if (productInfo.querySelector(':scope > .product__purchase-panel')) return;

        const price = productInfo.querySelector(':scope > .product__price');
        const productForm = productInfo.querySelector(':scope > .product-form-wrapper');

        if (!price || !productForm) return;

        const klarna = productInfo.querySelector(
          ':scope > .shopify-app-block:has(klarna-placement), :scope > .shopify-app-block[id*="klarna"]'
        );
        const panel = document.createElement('div');

        panel.className = 'product__purchase-panel';
        price.before(panel);
        panel.append(price, productForm);

        if (klarna) panel.append(klarna);
      });
    };

    const placeTitleImageAfterHighlights = (productInfo) => {
      const image = productInfo.querySelector(':scope > .product__title-image');
      if (!image) return;

      const highlight = Array.from(productInfo.querySelectorAll(':scope > .rte')).find((block) =>
        block.querySelector(':scope > .not-rte > p strong')
      );
      if (highlight && image.previousElementSibling !== highlight) highlight.after(image);
    };

    const initializeGalleryPromotions = (scope) => {
      scope.querySelectorAll('.featured-product').forEach((featuredProduct) => {
        if (featuredProduct.elasticaGalleryPromotionObserver) return;

        const gallery = featuredProduct.querySelector(':scope > .product__gallery-container');
        const productInfo = featuredProduct.querySelector(':scope > product-info.product__info');
        if (!gallery || !productInfo) return;

        const syncPromotion = () => {
          placeTitleImageAfterHighlights(productInfo);
          const label = productInfo.querySelector('.title__wrapper .title__promotion');
          const firstMedia = gallery.querySelector('media-gallery .product__media-list > .product__media[data-media-type="image"]:not([hidden])');
          const current = gallery.querySelector('.product__gallery-promotion');

          if (!label || !firstMedia) {
            current?.remove();
            featuredProduct.classList.remove('gallery-promotion-ready');
            return;
          }

          if (
            current?.parentElement === firstMedia &&
            current.textContent === label.textContent &&
            current.getAttribute('style') === label.getAttribute('style')
          ) {
            featuredProduct.classList.add('gallery-promotion-ready');
            return;
          }

          current?.remove();
          const promotion = label.cloneNode(true);
          promotion.classList.add('product__gallery-promotion');
          firstMedia.append(promotion);
          featuredProduct.classList.add('gallery-promotion-ready');
        };

        let updateQueued = false;
        const queueSync = () => {
          if (updateQueued) return;
          updateQueued = true;
          requestAnimationFrame(() => {
            updateQueued = false;
            syncPromotion();
          });
        };

        const observer = new MutationObserver(queueSync);
        observer.observe(productInfo, { childList: true, subtree: true, characterData: true, attributes: true });
        observer.observe(gallery, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
        featuredProduct.elasticaGalleryPromotionObserver = observer;
        syncPromotion();
      });
    };

    const prepareLightboxVideo = (videoMedia) => {
      if (!videoMedia || videoMedia.dataset.elasticaPrepared === 'true') return;

      const button = videoMedia.querySelector('.play-button');
      button?.removeAttribute('id');
      videoMedia.removeAttribute('aria-controls');

      if (videoMedia.hasAttribute('host')) return;

      const template = videoMedia.querySelector('template');
      const templateVideo = template?.content.firstElementChild;
      if (template && templateVideo) {
        template.replaceWith(templateVideo.cloneNode(true));
      }

      const video = videoMedia.querySelector('video');
      if (!video) return;

      videoMedia.dataset.elasticaPrepared = 'true';
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.muted = false;
      video.defaultMuted = false;
      video.controls = true;
      video.playsInline = true;
      video.preload = 'metadata';

      video.addEventListener('play', () => {
        videoMedia.setAttribute('loaded', '');
        videoMedia.setAttribute('playing', '');
      });
      video.addEventListener('pause', () => videoMedia.removeAttribute('playing'));
      video.addEventListener('ended', () => videoMedia.removeAttribute('playing'));
      video.load();
    };

    const openMobileVideoLightbox = (button) => {
      const media = button.closest('.product__media[data-media-type="video"]');
      const gallery = button.closest('media-gallery');
      const slider = gallery?.querySelector('slider-element');

      if (!media || !gallery || !slider) return;

      const visibleMedia = Array.from(slider.itemsToShow || []);
      const mediaItems = visibleMedia.length > 0
        ? visibleMedia
        : Array.from(slider.querySelectorAll('.product__media:not([hidden])'));
      const index = mediaItems.indexOf(media);

      if (index < 0) return;

      let lightboxObserver;
      const prepareCurrentLightboxVideo = () => {
        const videoMedia = document.querySelector('.pswp__video-container video-media');
        if (!videoMedia) return false;

        lightboxObserver?.disconnect();
        prepareLightboxVideo(videoMedia);
        return true;
      };

      lightboxObserver = new MutationObserver(prepareCurrentLightboxVideo);
      lightboxObserver.observe(document.body, { childList: true, subtree: true });

      gallery.dispatchEvent(new CustomEvent('lightbox:open', {
        bubbles: true,
        detail: { index }
      }));

      requestAnimationFrame(prepareCurrentLightboxVideo);
      setTimeout(() => lightboxObserver.disconnect(), 10000);
    };

    const initializeMobileVideoPreviews = (scope) => {
      scope.querySelectorAll('.product__media[data-media-type="video"] video-media .play-button').forEach((button) => {
        if (button.dataset.elasticaMobilePreview === 'true') return;

        button.dataset.elasticaMobilePreview = 'true';
        button.addEventListener('click', (event) => {
          if (!mobileVideoPreviewQuery.matches) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          openMobileVideoLightbox(button);
        }, { capture: true });
      });
    };

    const initializeLightboxVideoPlayback = () => {
      if (window.__elasticaLightboxVideoPlaybackInitialized) return;

      window.__elasticaLightboxVideoPlaybackInitialized = true;
      document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const button = target.closest('.pswp__video-container video-media .play-button');
        if (!button) return;

        const videoMedia = button.closest('video-media');
        if (!videoMedia) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        prepareLightboxVideo(videoMedia);

        if (videoMedia.hasAttribute('host')) {
          videoMedia.play?.();
          return;
        }

        const video = videoMedia.querySelector('video');
        if (!video) return;

        video.muted = false;
        video.defaultMuted = false;
        video.controls = true;
        const playRequest = video.play();
        playRequest?.then?.(() => {
          videoMedia.setAttribute('loaded', '');
          videoMedia.setAttribute('playing', '');
        });
        playRequest?.catch?.(() => {
          videoMedia.removeAttribute('loaded');
          videoMedia.removeAttribute('playing');
        });
      }, { capture: true });
    };

    const initializeProductEnhancements = (scope) => {
      initializePurchasePanels(scope);
      scope.querySelectorAll('product-info.product__info').forEach(placeTitleImageAfterHighlights);
      initializeGalleryPromotions(scope);
      initializeMobileVideoPreviews(scope);
      initializeLightboxVideoPlayback();
    };

    patchMediaGalleryAutoplay();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeProductEnhancements(document), { once: true });
    } else {
      initializeProductEnhancements(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeProductEnhancements(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.featured-product').forEach((featuredProduct) => {
        featuredProduct.elasticaGalleryPromotionObserver?.disconnect();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
